import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import {
  errorAlertHandle,
  successAlertHandle,
} from "../../../../utils/utilFunctions";

export const submitReceipt = async (payload, dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify(payload);
    const res = await axios.post("/api/proc/receipt", body, config);
    successAlertHandle("Receipt added successfully!", dispatch);
    return true;
  } catch (err) {
    errorAlertHandle(err, dispatch);
    return false;
  }
};

export const submitStock = async (payload, dispatch) => {
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify(payload);
    const res = await axios.post("/api/trade", body, config);
    successAlertHandle("Stock added successfully!", dispatch);
  } catch (err) {
    errorAlertHandle(err, dispatch);
  }
};

export const getStockReport = createAsyncThunk(
  "app/getStockReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
    });
    const res = await axios.post(
      `/api/report/stock/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getStockEntryReport = createAsyncThunk(
  "app/getStockEntryReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: 1,
    });
    const res = await axios.post(
      `/api/report/trade/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const getStockDistributionReport = createAsyncThunk(
  "app/getStockDistributionReport",
  async ({ start, limit, filters }) => {
    const config = { headers: { "Content-Type": "application/json" } };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: 0,
    });
    const res = await axios.post(
      `/api/report/trade/filter?start=${start}&limit=${limit}`,
      body,
      config
    );
    return res.data;
  }
);

export const fetchVoucher = async () => {
  try {
    const res = await axios.get(`api/voucher`);
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const fetchWarehouseStocks = async () => {
  try {
    const res = await axios.get("api/trade/warehouse-stocks");
    return res.data;
  } catch (error) {
    console.log(error.message);
  }
};

export const saveStockDistribution = createAsyncThunk(
  "app/saveStockDistribution",
  async ({ data, resetForm, refresh }, { dispatch, rejectWithValue }) => {
    try {
      const config = { headers: { "Content-Type": "application/json" } };
      const body = JSON.stringify({
        ...data,
      });
      const res = await axios.post("/api/trade", body, config);
      successAlertHandle("Stock Distribution saved successfully!", dispatch);
      refresh(true);
      resetForm();
      return res.data;
    } catch (err) {
      refresh(true);
      resetForm();
      errorAlertHandle(err, dispatch);
      return rejectWithValue(err.response.data.error);
    }
  }
);

export const exportStockReport = async ({ filters }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      // timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });
    const res = await axios.post(`/api/download/stock/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};

export const exportTradeReport = async ({ filters, type }) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      ...filters,
      timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      type: type
    });
    const res = await axios.post(`/api/download/trade/filter`, body, config);
    return res.data;
  } catch (err) {
    throw err;
  }
};